<template>
  <div class="media-gallery-desktop">
    <ul
      ref="lclGallery"
      class="media-gallery-desktop__list"
    >
      <li
        v-for="item in galleryItems"
        :key="item.src"
        class="media-gallery-desktop__item"
        :class="[{ 'item-video': item.type === 'video' }, 'item-' + item.visual]"
        :data-item="item.index"
      >
        <UiVideo
          v-if="item.type === 'video'"
          :src="item.src"
          width="720"
          height="960"
          :autoplay="true"
          :controls="false"
          playsinline
          loop
          muted
          class="media-gallery-desktop__video"
        />

        <img
          v-else-if="item.type === 'image'"
          :src="getImageFromProvider(item, { width: 720, height: 960 })"
          :alt="item.alt"
          width="720"
          height="960"
          loading="lazy"
          class="media-gallery-desktop__img"
          @click="openModal(item.index)"
        >
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
const {
  galleryItems,
  gallery,
  getImageFromProvider,
  setItem,
} = useUiMediaGallery()

const lclGallery = ref<null | HTMLElement>(null)

const { open: openFullscreen } = useUiDialog('media-gallery')

const openModal = (index: number) => {
  setItem(index)
  openFullscreen()
}

watchEffect(() => {
  gallery.value = lclGallery.value
})
</script>

<style src="~layers/app/components/Ui/MediaGallery/DesktopMain.css" />
